module.exports = __webpack_public_path__ + "img/ferie_holiday_level_alert.19b9f449.png";